import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { Network } from '@/modules/__generated__/graphql/switchboard-generated';
import { selectNetworkImages } from '@/modules/shared/lib/network-brand-utils';
import { NetworkImage } from './network-image';

/**
 * Network icon for mobile view
 */
function NetworkIcon(t0) {
  const $ = _c(8);
  const {
    network
  } = t0;
  let t1;
  if ($[0] !== network) {
    t1 = selectNetworkImages(network, "icon");
    $[0] = network;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageSelection = t1;
  if (imageSelection.source === "none") {
    const t2 = network.name ?? "";
    let t3;
    if ($[2] !== t2) {
      t3 = <Image src="/networks/logos/unknown.png" alt={t2} width={36} height={36} priority={true} fetchPriority="high" className="min-w-8 lg:hidden" />;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t2 = network.name ?? "";
  let t3;
  if ($[4] !== imageSelection.darkImage || $[5] !== imageSelection.lightImage || $[6] !== t2) {
    t3 = <NetworkImage lightImage={imageSelection.lightImage} darkImage={imageSelection.darkImage} alt={t2} size={36} lightClassName="block min-w-8 lg:hidden dark:hidden" darkClassName="hidden min-w-8 lg:hidden dark:block lg:dark:hidden" singleClassName="min-w-8 lg:hidden" useImgTag={false} showName={false} />;
    $[4] = imageSelection.darkImage;
    $[5] = imageSelection.lightImage;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export { NetworkIcon };